import style from '../index.less';

interface Props {
    onClick?: (e: React.MouseEvent, key: string | number) => void;
}

const KeyBoard: React.FC<Props> = ({ onClick: originalOnClick }) => {
    const onClick = (
        event: React.MouseEvent<HTMLLIElement>,
        key: number | string,
    ) => {
        originalOnClick?.(event, key);
    };

    return (
        <ul className={style.keyboardContainer}>
            <li onClick={(e) => onClick?.(e, 1)}>1</li>
            <li onClick={(e) => onClick?.(e, 2)}>2</li>
            <li onClick={(e) => onClick?.(e, 3)}>3</li>
            <li onClick={(e) => onClick?.(e, 4)}>4</li>
            <li onClick={(e) => onClick?.(e, 5)}>5</li>
            <li onClick={(e) => onClick?.(e, 6)}>6</li>
            <li onClick={(e) => onClick?.(e, 7)}>7</li>
            <li onClick={(e) => onClick?.(e, 8)}>8</li>
            <li onClick={(e) => onClick?.(e, 9)}>9</li>
            <li onClick={(e) => onClick?.(e, '*')}>*</li>
            <li onClick={(e) => onClick?.(e, 0)}>0</li>
            <li onClick={(e) => onClick?.(e, '#')}>#</li>
        </ul>
    );
};

export default KeyBoard;
